import { Field, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import InputText from '../../../components/Inputs/InputText/InputText';
import {
  Card,
  Link,
  Button,
  Typography,
  FileUploader,
} from '@hid-galaxy-ui/galaxy-react';
import styles from './AccountCreate.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';
import { useHistory } from 'react-router-dom';
import buildPATHS, {
  getPathWithBaseUrl,
  PATHS_WITH_PARAMS,
} from '../../../utils/paths';
import * as Yup from 'yup';
import { InputsSchema } from '../../../hooks/buildRegisterForm/validationSchema';
import InputPassword from '../../../components/Inputs/InputPassword/InputPassword';
import InputSelectCountry from '../../../components/Inputs/InputSelectCountry/InputSelectCountry';
import InputDatePicker from '../../../components/Inputs/InputDatePicker/InputDatePicker';
import cx from 'classnames';
import {
  craeteAccount,
  getDisabilitiesCategoriesApi,
  uploadFile,
} from '../../../services/app-user/app-user';
import {
  NotificationError,
  NotificationSuccess,
} from '../../../utils/notification';
import OtpValidationForm from '../components/OtpValidationForm/OtpValidationForm';
import {
  getCurrentPathname,
  getTranslation,
  isQueryParamsExist,
} from '../../../utils/functions';
import { GENDER_ENUM_TRANSLATIONS, GENDER_OPTIONS } from '../constant';
import { IAppProps } from '../../../App';
import BoxLogo from '../../../components/BoxLogo/BoxLogo';
import { ICreateUpdateAccountParams } from '../../../services/app-user/IAppUser';
import { useLocation } from 'react-router-dom';
import PasswordGuideline from '../../../components/PasswordGuideline/PasswordGuideline';
import LodashUtils from '../../../utils/lodashUtils';
import InputDropdown from '../../../components/Inputs/InputDropdown/InputDropdown';
import { ISetFieldValue } from '../../../utils/interfaces/IFormik';
import { FILE_UPLOAD_MAX_SIZE_MB } from '../../../components/Inputs/InputFileUploadSingle/file-upload-constants';
import DisabilityCategoriesFields from '../components/DisabilityCategories/DisabilityCategories';
import { isAuthenticated } from '../../../utils/authService';
import allActions from '../../../store/actions';
import { getFileNameFromUrl } from '../../../utils/fileUtils';
import { FISCAL_CODE_REGEX } from '../../../constants/regex';
import {
  COUNTRY_CODE,
  getCountryListOptions,
} from '../../../constants/countryList';
import { accountCreateEditValidationSchema } from './AcoountCreateValidationSchema';
import InputPhoneNumber from '../../../components/Inputs/InputPhoneNumber/InputPhoneNumber';
import { setLocalStorageItem } from '../../../utils/sessionUtils';
import { PROJECT_REGISTRATION_KEY } from '../../../constants/sessionStorage';
import {
  getProjectKey,
  getUrlLastPathValue,
} from '../../../environments/url-helpers';
import InputFileUploadSingleWithWebcam from '../../../components/Inputs/InputFileUploadSingleWithWebcam/InputFileUploadSingleWithWebcam';

// interface IAccountCreateProps extends IAppProps {
//   accountData?: any;
//   isEdit?: boolean;
// }

export interface IFileData {
  fileDetails: any;
  error?: { message: string };
}

const AccountCreate = (props: IAppProps) => {
  const { toasts, setToasts } = props;
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState('');

  const [uploadAccountDocumentFiles, setUploadAccountDocumentFiles] = useState<
    string[]
  >([]);

  const history = useHistory();
  const PATHS = buildPATHS();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated()) {
      history.push(PATHS.my_forms);
    }

    const currentPath = getCurrentPathname();

    setLocalStorageItem(PROJECT_REGISTRATION_KEY, currentPath);
  }, []);

  if (!isEdit && location.pathname === PATHS.account_edit) {
    setIsEdit(true);
  }

  const [validated, setValidated] = useState(false);

  const validatedValue = (val) => {
    setValidated(val);
  };

  const accountCreateValidationSchema = {
    password: InputsSchema.TEXTFIELD({
      required: true,
      properties: {
        errorMessageRequired: 'PASSWORD_REQUIRED',
      },
    }),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref('password'), null],
        getTranslation('PASSWORDS_MUST_MATCH'),
      )
      .required(getTranslation('CONFIRM_PASSWORD_MSG')),
    country: Yup.string().required(getTranslation('COUNTRY_OF_BIRTH_REQUIRED')),
  };
  const buildFormValidation = () => {
    return Yup.object().shape({
      ...accountCreateEditValidationSchema(getTranslation),
      ...accountCreateValidationSchema,
    });
  };

  const handleSubmit = async (values, { setFieldError }) => {
    const projectKey = getProjectKey();
    if (!validated) {
      setFieldError(
        'password',
        getTranslation('PASSWORD_GUIDLINES_NOT_MATCHED'),
      );
      return;
    }

    // Prepare ID documents array: [front, back] - maintain index positions
      const idDocumentsArray = [
        values['idDocuments-0'],
        values['idDocuments-1'],
      ].map((v) => (typeof v === 'string' ? v.trim() : ''));
      const hasIdDocuments = idDocumentsArray.some(
        (url) => url && url.trim() !== '',
      );

    if (
      idDocumentsArray.filter((url) => url).length !== 2
    ) {
      setToasts([
        ...toasts,
        ...NotificationError('REQUIRED_DOCUMENTS_ID_COUNT_MISMATCH'),
      ]);
      return;
    }

    if (
      values?.disabilityCategoryCode &&
      values.requiredDocumentsCount !==
        values.documentUrls?.filter((url) => url && url.trim() !== '').length
    ) {
      setToasts([
        ...toasts,
        ...NotificationError('REQUIRED_DOCUMENTS_COUNT_MISMATCH'),
      ]);
      return;
    }

    try {
      const filteredDocumentUrls =
        values.documentUrls?.filter((url) => url && url.trim() !== '') || [];

  
      const payload: ICreateUpdateAccountParams = {
        ...LodashUtils.omit(values, ['confirmPassword']),
        idDocuments: idDocumentsArray,
        ...(filteredDocumentUrls.length > 0 && { documentUrls: filteredDocumentUrls }),
        ...(projectKey && {
          projectId: projectKey,
        }),
      };

      const response = await craeteAccount(payload);
      setRegisteredEmail(values.email);
      setShowOtpForm(true);
      setToasts([...toasts, ...NotificationSuccess('SUCCESSFULLY_REGISTERED')]);
    } catch (error) {
      setToasts([
        ...toasts,
        ...NotificationError(
          error?.response?.data?.statusReason || 'AN_ERROR_OCCURED',
        ),
      ]);
    }
  };

  const handleLoginClick = () => {
    if (isQueryParamsExist()) {
      history.push(PATHS.login);
    } else {
      history.push(getPathWithBaseUrl(PATHS_WITH_PARAMS.login));
    }
  };

  const getTranslatedGenderOptions = () => {
    return GENDER_OPTIONS.map((option) => ({
      label: getTranslation(GENDER_ENUM_TRANSLATIONS[option.value]),
      value: option.value,
    }));
  };

  const renderDocumentFields = (setFieldValue: ISetFieldValue) => {
    const documentLabels = [
      getTranslation('DOCUMENT_ID_FRONT'),
      getTranslation('DOCUMENT_ID_BACK'),
    ];
    const documentCount = 2;

    return (
      <div className={styles.documentWrapper}>
        {Array.from({ length: documentCount }, (_, index) => (
          <div key={`document-${index}`} className="hid-spacing__mb-04">
            <Typography
              className="hid-spacing__mb-02"
              variant={TypographyVariantEnum.BodyLongMarketing}
            >
              <label className="hid-form-element__label">
                {documentLabels[index] ||
                  `${getTranslation('DOCUMENT')} ${index + 1}`}
                <span className="hid-form-element__label-asterisk">*</span>
              </label>
            </Typography>
            <Field
              name={`idDocuments-${index}`}
              component={InputFileUploadSingleWithWebcam}
              extensiontype={['jpg', 'jpeg', 'png']}
              enableWebcam={true}
            />
          </div>
        ))}
        <Typography variant={TypographyVariantEnum.BodyShortProduct}>
          {getTranslation('DOCUMENT_UPLOAD_INSTRUCTION')}
        </Typography>
      </div>
    );
  };

  const renderDocumentIdData = (documentIndex: number) => {
    const url = uploadAccountDocumentFiles[documentIndex];
    if (url) {
      return [
        {
          fileDetails: {
            name: getFileNameFromUrl(url),
          },
        },
      ];
    }
    return [];
  };

  const handleFileUpload = async (
    e,
    data,
    documentIndex: number,
    setFieldValue: ISetFieldValue,
  ) => {
    dispatch(allActions.appConfigActions.setLoader(true));

    const filteredNewFiles = data.filter(
      (file) => file.fileDetails instanceof File,
    );
    if (filteredNewFiles.length > 0) {
      const fileUploadResponse = await uploadAccountDocument(filteredNewFiles);
      dispatch(allActions.appConfigActions.setLoader(false));

      if (!fileUploadResponse) {
        return;
      }

      const updatedDocumentUrls = [...uploadAccountDocumentFiles];
      updatedDocumentUrls[documentIndex] = fileUploadResponse[0];
      setDocumentUrls(updatedDocumentUrls, setFieldValue);
    }
  };

  const setDocumentUrls = (
    dataToSet: string[],
    setFieldValue: ISetFieldValue,
  ) => {
    const documentsArray = [...dataToSet, '', ''].slice(0, 2);
    setFieldValue('idDocuments', documentsArray);
    setUploadAccountDocumentFiles(documentsArray);
  };

  const handleFileDelete = (
    e: React.MouseEvent<HTMLElement>,
    data: { fileDetails: { name: string } },
    deletedFile: { name: string },
    documentIndex: number,
    setFieldValue: ISetFieldValue,
  ) => {
    const updatedDocumentUrls = [...uploadAccountDocumentFiles];
    updatedDocumentUrls[documentIndex] = '';
    setDocumentUrls(updatedDocumentUrls, setFieldValue);
  };

  const uploadAccountDocument = async (data: IFileData[]) => {
    return await Promise.all(
      data.map(async (fileObj) => {
        const { fileDetails } = fileObj;
        try {
          const response = await uploadFile(fileDetails);
          return response?.location;
        } catch (error) {
          setToasts([...toasts, ...NotificationError('AN_ERROR_OCCURED')]);
        }
      }),
    );
  };

  const countryOptions = () =>
    getCountryListOptions().map((option) => {
      return {
        label: option.label,
        value: option.key,
      };
    });

  const renderRegistrationForm = () => {
    return (
      <Formik
  initialValues={{
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    country: COUNTRY_CODE.ITALY,
    dateOfBirth: '',
    disabilityCategoryCode: '',
    documentUrls: undefined,
    requiredDocumentsCount: 0,
          // projectId: projectKey,
    gender: '',
    fiscalCode: '',
    placeOfBirth: '',
    idDocuments: [],
  }}
  validationSchema={buildFormValidation()}
  onSubmit={handleSubmit}
>
        {({ isValid, values, setFieldValue }) => (
      <>
        <Form className={cx('hid-spacing__px-03', 'register-form')}>
              <BoxLogo />
              <Typography
                className="hid-text-center hid-spacing__mb-04"
                variant={TypographyVariantEnum.H2}
              >
                {getTranslation('CREATE_NEW_ACCOUNT')}
              </Typography>
              <Field
                key="email"
                component={InputText}
                label={getTranslation('EMAIL')}
                type="email"
                name="email"
                id="email"
                required={true}
              />
              <Field
                key="firstName"
                component={InputText}
                label={getTranslation('FIRSTNAME')}
                name="firstName"
                id="firstName"
                required={true}
              />
              <Field
                key="lastName"
                component={InputText}
                label={getTranslation('LASTNAME')}
                name="lastName"
                id="lastName"
                required={true}
              />
              <Field
                key="gender"
                component={InputDropdown}
                label={getTranslation('GENDER')}
                name="gender"
                id="gender"
                required={true}
                options={getTranslatedGenderOptions()}
              />
              <Field
                key="phoneNumber"
                component={InputPhoneNumber}
                label={getTranslation('MOBILENUMBER')}
                name="phoneNumber"
                id="phoneNumber"
                type="number"
              />

              <Field
                key="country"
                component={InputDropdown}
                label={getTranslation('COUNTRYOFBIRTH')}
                name="country"
                id="country"
                required={true}
                options={countryOptions()}
              />

              <Field
                key="dateOfBirth"
                component={InputDatePicker}
                label={getTranslation('DATEOFBIRTH')}
                name="dateOfBirth"
                id="dateOfBirth"
                max={new Date()}
                required={true}
              />
              <Field
                key="placeOfBirth"
                component={InputText}
                label={getTranslation('PLACEOFBIRTH')}
                name="placeOfBirth"
                id="placeOfBirth"
                required={true}
              />
              <Field
                key="fiscalCode"
                component={InputText}
                label={getTranslation('FISCALCODE')}
                name="fiscalCode"
                id="fiscalCode"
                required={true}
              />

          {renderDocumentFields(setFieldValue)}

              <DisabilityCategoriesFields
                toasts={toasts}
                setToasts={setToasts}
                // setFieldValue={setFieldValue}
                // onSelectDisabilityCategory={(selectedValue: ISelectOptions) => {
                //   setFieldValue('disabilityCategoryCode', selectedValue.value);
                // }}
              />

              {/* { uploadDisabilitiesCategoryDocument > 0 && renderDisabilityCategoryDocumentUpload()} */}
              <Field
                key="password"
                component={InputPassword}
                label={getTranslation('PASSWORD')}
                name="password"
                id="password"
                required={true}
              />
              <Field
                key="confirmPassword"
                component={InputPassword}
                label={getTranslation('CONFIRM_PASSWORD')}
                name="confirmPassword"
                id="confirmPassword"
                required={true}
              />

              <PasswordGuideline
                setValidated={(isValidated) => validatedValue(isValidated)}
                password={values.password}
              />
              {/* {errors.confirmPassword && touched.confirmPassword && (
                <div className={styles.error}>{`${errors.confirmPassword}`}</div>
              )} */}

          <div className="hid-flex hid-flex-row hid-flex-jc-end hid-spacing__mt-05">
            <Button
                  // disabled={!isValid || !validated}
              label={getTranslation('REGISTER')}
              type="submit"
            />
          </div>
              <div className="hid-flex hid-flex-jc-center hid-spacing__mt-07">
                <Typography variant={TypographyVariantEnum.BodyShortProduct}>
                  {getTranslation('ALREADY_HAVE_AN_ACCOUNT')}
                </Typography>
                <Link
                  onClick={() => {
                    handleLoginClick();
                  }}
                >
                  {getTranslation('LOGIN')}
                </Link>
              </div>
        </Form>
      </>
        )}
</Formik>
    );
  };

  return (
    <div className={styles.formWrapper}>
      <Card className={styles.card}>
        {showOtpForm ? (
          <OtpValidationForm
            registeredEmail={registeredEmail}
            setToasts={setToasts}
            toasts={toasts}
          />
        ) : (
          renderRegistrationForm()
        )}
      </Card>
    </div>
  );
};

export default AccountCreate;
